/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ReferralStatusEnum;

(function (ReferralStatusEnum) {
  ReferralStatusEnum["APPROVED"] = "approved";
  ReferralStatusEnum["DECLINED"] = "declined";
  ReferralStatusEnum["PENDING"] = "pending";
})(ReferralStatusEnum || (ReferralStatusEnum = {}));